/**
 * Fetch payroll-ready spans (already split per civil day 00:00–24:00).
 * Mirrors getJobOrders signature for consistency.
 *
 * @param {string[]} status                e.g., ["Done"]
 * @param {string[]} serviceReportStatus   e.g., ["Done"]
 * @param {string|null} startDate          "YYYY-MM-DD" (required with endDate)
 * @param {string|null} endDate            "YYYY-MM-DD" (required with startDate)
 * @param {string|null} technicianId
 * @returns {Promise<Array>}               Array of payroll spans
 */
export async function getJobOrdersForPayroll(
  status = [],
  serviceReportStatus = [],
  startDate = null,
  endDate = null,
  technicianId = null
) {
  try {
    // Base API URL for payroll endpoint
    let apiUrl =
      "https://00ab2yi278.execute-api.ap-southeast-1.amazonaws.com/prod/getJobOrdersForPayroll";

    const qp = [];

    if (status.length > 0) {
      qp.push(`status=${status.map(encodeURIComponent).join(",")}`);
    }
    if (serviceReportStatus.length > 0) {
      qp.push(
        `service_report_status=${serviceReportStatus
          .map(encodeURIComponent)
          .join(",")}`
      );
    }
    if (startDate && endDate) {
      qp.push(`start_date=${encodeURIComponent(startDate)}`);
      qp.push(`end_date=${encodeURIComponent(endDate)}`);
    }
    if (technicianId) {
      qp.push(`technician_id=${encodeURIComponent(technicianId)}`);
    }

    if (qp.length > 0) apiUrl += `?${qp.join("&")}`;

    console.log("🌐 [PAYROLL API] Calling Lambda:", apiUrl);

    const res = await fetch(apiUrl, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!res.ok) {
      console.error(
        `Error: Failed to fetch payroll spans. Status: ${res.status}`
      );
      return [];
    }

    const data = await res.json();
    
    // 🔍 DEBUG: Log the raw response from Lambda
    console.log("🔍 [PAYROLL API] Raw Lambda response:", data);
    console.log("🔍 [PAYROLL API] Number of spans returned:", data?.spans?.length || 0);
    
    // The Lambda returns { spans: [...] }
    if (data && Array.isArray(data.spans)) {
      if (data.spans.length > 0) {
        console.log("📋 [PAYROLL API] Sample span:", data.spans[0]);
      }
      return data.spans;
    }
    // In case the backend returns a raw array in the future
    if (Array.isArray(data)) return data;

    return [];
  } catch (err) {
    console.error(
      "Error: Network or other error occurred while fetching payroll spans.",
      err
    );
    return [];
  }
}
